module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-message",
    class: _vm.className
  }, [_c('div', {
    staticClass: "chat-message_user"
  }, [_vm._v(_vm._s(_vm.message.user))]), _c('div', {
    staticClass: "chat-message_text"
  }, [_vm._v(_vm._s(_vm.message.text))]), _c('div', {
    staticClass: "chat-message_time"
  }, [_vm._v(_vm._s(_vm.time))]), _c('div', {
    staticClass: "chat-message_error"
  }, [_vm._v(_vm._s(_vm.message.error))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-14e3835e"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-message.vue
// module id = 94
// module chunks = 1